"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_IS_STATUS_MODAL_OPEN = exports.SET_API_STATUS = exports.SET_SEARCH_RESULT = exports.SET_GLOBAL_STYLE = exports.SET_USER_DATA = exports.SET_IS_SIDEBAR_OPEN = exports.FETCH_LOG_OUT = exports.FETCH_SEARCH = exports.slice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const reduxUtils_1 = require("@utils/reduxUtils");
const data_1 = require("./data");
exports.slice = (0, toolkit_1.createSlice)({
    name: 'common',
    initialState: data_1.initialState,
    reducers: {
        FETCH_SEARCH: (0, reduxUtils_1.sendPayloadObject)(reduxUtils_1.ReduxResponseColumns.PAYLOAD),
        FETCH_LOG_OUT: (state) => {
            return Object.assign(Object.assign({}, state), { userData: data_1.userData, routes: [], isLoggedIn: false });
        },
        SET_IS_SIDEBAR_OPEN: (state, action) => {
            return Object.assign(Object.assign({}, state), { sidebarStatus: Object.assign(Object.assign({}, state.sidebarStatus), { isOpen: action.payload }) });
        },
        SET_USER_DATA: (0, reduxUtils_1.sendPayloadObject)('userData'),
        SET_GLOBAL_STYLE: (0, reduxUtils_1.sendPayloadObject)('globalStyle'),
        SET_SEARCH_RESULT: (0, reduxUtils_1.sendPayloadObject)('searchResult'),
        SET_API_STATUS: (0, reduxUtils_1.sendPayloadObject)('apiStatus'),
        SET_IS_STATUS_MODAL_OPEN: (state, action) => {
            const { isOpen, statusModalType, message, detail } = action.payload;
            return Object.assign(Object.assign({}, state), { statusModal: {
                    statusModalType,
                    isOpen,
                    customMessage: message,
                    customNote: detail
                } });
        }
    }
});
_a = exports.slice.actions, exports.FETCH_SEARCH = _a.FETCH_SEARCH, exports.FETCH_LOG_OUT = _a.FETCH_LOG_OUT, exports.SET_IS_SIDEBAR_OPEN = _a.SET_IS_SIDEBAR_OPEN, exports.SET_USER_DATA = _a.SET_USER_DATA, exports.SET_GLOBAL_STYLE = _a.SET_GLOBAL_STYLE, exports.SET_SEARCH_RESULT = _a.SET_SEARCH_RESULT, exports.SET_API_STATUS = _a.SET_API_STATUS, exports.SET_IS_STATUS_MODAL_OPEN = _a.SET_IS_STATUS_MODAL_OPEN;
exports.default = exports.slice.reducer;
